import { Component, OnInit } from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {Subject} from 'rxjs/Subject';

@Component({
  selector: 'app-modal-generic',
  templateUrl: './modal-generic.component.html'
})
export class ModalGenericComponent implements OnInit {

  options: any = {
    buttons: []
  };
  public onClose: Subject<boolean>;

  constructor(
    public bsModalRef: BsModalRef,
  ) {
    this.onClose = new Subject();
  }

  ngOnInit() {
  }

  clickedButton(button: any) {
    if (this.options.isNavigate) {
      if (button === 'Rimani') {
        this.onClose.next(false);
      } else {
        this.onClose.next(true);
      }
    } else {
      this.onClose.next(button);
    }
    this.bsModalRef.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modal-generic/modal-generic.component.ts